import { render, staticRenderFns } from "./add-parameter.vue?vue&type=template&id=2d457320&scoped=true&"
import script from "./add-parameter.vue?vue&type=script&lang=ts&"
export * from "./add-parameter.vue?vue&type=script&lang=ts&"
import style0 from "./add-parameter.vue?vue&type=style&index=0&id=2d457320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d457320",
  null
  
)

export default component.exports